import type { Job } from '../lib/types';
import { formatDate, label, payBand } from '../lib/format';
import { Pill } from './Pill';

export function JobCard({ job }: { job: Job }) {
  // Both of these were stored and shown nowhere. Pay was served on the wire
  // from the first release and never rendered; the sponsorship statement had
  // no code path that could populate it until the posting body was read.
  const pay = payBand(job.compensationMin, job.compensationMax, job.currency);
  return (
    <article className="card job-card">
      <div className="pill-row">
        <Pill value={job.status} tone={job.status === 'open' ? 'positive' : 'neutral'} />
        {/* The role family was classified, stored and served from the first
            release and shown nowhere, so the taxonomy the registry reads
            hiring through was invisible to the reader. `Pill` labels what it
            is handed, so the snake_cased value does not reach the page. */}
        {job.normalizedFunction && <Pill value={job.normalizedFunction} tone="accent" />}
        {job.normalizedSeniority && <Pill value={job.normalizedSeniority} />}
      </div>
      <div>
        <h3>{job.title}</h3>
        <p className="job-card__company">{job.companyName ?? 'Company'}</p>
        <p className="muted">{job.location || 'Location unspecified'} · {label(job.remotePolicy)}</p>
        {pay && <p className="job-card__pay">{pay}</p>}
        {/* Quoted, not summarised into a yes or no: the answers include an
            offer, a refusal, and support "based on an individual's unique
            circumstances", and the last is not a boolean. */}
        {job.visaLanguage && <p className="muted job-card__visa">{job.visaLanguage}</p>}
      </div>
      <div className="card__footer">
        <small>Seen {formatDate(job.lastSeenAt)}</small>
        <a href={job.canonicalUrl} target="_blank" rel="noreferrer">View role ↗</a>
      </div>
    </article>
  );
}
